import { RequiredPolicyDetails } from 'interfaces/ClientInfo';
import { usePartnerConfig } from '../../contexts/partnerConfig';
import locale from '../../models/locale';
import { colorFillColorWithState } from 'mt-react-theme-manager';
import { Fragment, ReactNode } from 'react';

interface RequiredPolicyLinkProps {
  policyDetails: RequiredPolicyDetails;
}

function RequiredPolicyLink({
  policyDetails: { en, ja, url, key }
}: RequiredPolicyLinkProps) {
  const className = colorFillColorWithState('primary');

  return (
    <a
      href={url}
      key={key}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {locale.language === 'en' ? en : ja}
    </a>
  );
}

export interface RequiredPolicyLinksProps {
  jaSeparator?: string;
  isAppended?: boolean;
  isInSentence?: boolean;
}

export function RequiredPolicyLinks({
  jaSeparator,
  isAppended = false,
  isInSentence = true
}: RequiredPolicyLinksProps): ReactNode {
  const { config } = usePartnerConfig();
  const { language } = locale;

  const policiesToDisplay = config?.myAccount?.requiredPolicies;

  if (!isInSentence) {
    return policiesToDisplay?.map((policyDetails) => (
      <RequiredPolicyLink policyDetails={policyDetails} />
    ));
  }

  return policiesToDisplay?.map(({ key, en, ja, url }, index) => {
    let separator = language === 'en' ? ', ' : jaSeparator;

    if (index === 0) separator = '';

    if (
      isAppended &&
      index === policiesToDisplay.length - 1 &&
      language === 'en'
    ) {
      separator = ' and ';
    }

    return (
      <Fragment key={key}>
        <span>{separator}</span>
        <RequiredPolicyLink policyDetails={{ key, en, ja, url }} />
      </Fragment>
    );
  });
}
